import { useEffect, useLayoutEffect } from 'react';
import { Navigate } from 'react-router';
import { FullPageLoader } from '../../components/common';
import { homePathFor, useMe } from '../../lib/auth';
import { revealApp } from '../../lib/prerender';
import { LandingPage } from './landing/LandingPage';

/** "/": the public website. Signed-in users go straight to their home screen. */
export default function Landing() {
  const me = useMe();
  const ready = !me.isPending && !me.data;

  useEffect(() => {
    document.title = 'Testpio: online test series platform for coaching institutes';
    document.documentElement.lang = 'en';
  }, []);

  // The pre-rendered copy of this page stays on screen until the app has drawn the same page;
  // swapping before paint means no flash.
  useLayoutEffect(() => {
    if (ready) revealApp();
  }, [ready]);

  // Links like /#demo from other pages: the sections exist only after the session check.
  useEffect(() => {
    if (!ready || !window.location.hash) return;
    document.getElementById(decodeURIComponent(window.location.hash.slice(1)))?.scrollIntoView();
  }, [ready]);

  if (me.isPending) return <FullPageLoader />;
  if (me.data) return <Navigate to={homePathFor(me.data.user.role)} replace />;
  return <LandingPage />;
}
